import { Component, ElementRef, EventEmitter, Input, Optional, Output, Self, ChangeDetectionStrategy, input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-coordinate-editor',
    templateUrl: './coordinate-editor.component.html',
    styleUrls: ['./coordinate-editor.component.scss'],
    providers: [{ provide: MatFormFieldControl, useExisting: CoordinateEditorComponent }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoordinateEditorComponent implements ControlValueAccessor, MatFormFieldControl<number[]> {

  static nextId = 0;

  @Input() placeholder = 'Enter Coordinates';
  @Input() required = false;
  @Input() disabled = false;
  @Input() errorState = false;
  readonly compact = input(false);
  @Output() valueChange = new EventEmitter<number[]>();

  private _value: number[] = [];

  @Input()
  get value(): number[] {
    return this._value;
  }

  set value(val: number[]) {
    this._value = val;
    this.valueChange.emit(this._value);
    this.onChange(this._value);
    this.stateChanges.next();
  }

  showUrlParser: any;
  mapUrl: any;

  @Input() set error(v: boolean) {
    this.errorState = v;
    this.stateChanges.next();
  }

  get empty() {
    return !this.value || this.value.length === 0;
  }

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  focused = false;
  stateChanges = new Subject<void>();
  controlType = 'app-coordinate-editor';
  id = `coordinate-editor-${CoordinateEditorComponent.nextId++}`;
  describedBy = '';

  onChange = (_: any) => { };
  onTouch = () => { };

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private elRef: ElementRef<HTMLElement>
  ) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  autofilled?: boolean;
  userAriaDescribedBy?: string;

  setDescribedByIds(ids: string[]): void { }

  writeValue(value: number[]): void {
    if (value !== null) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.stateChanges.next();
  }

  onContainerClick(event: MouseEvent): void {
    if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      const input = this.elRef.nativeElement.querySelector('input') as HTMLElement;
      if (input) {
        input.focus();
      }
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  extractLatLongFromUrl(url: string): [number, number] | null {
    const latLongRegex = /(?:ll=|@|cp=)(-?\d+\.\d+)(%2C|%7E|,)(-?\d+\.\d+)|\/([\d\.]+)\/([\d\.]+)\/z/i;
    const isYandex = url.includes('yandex');
    const match = url.match(latLongRegex);

    if (match) {
      if (match[1] && match[2] && match[3]) {
        const lat = parseFloat(isYandex ? match[3] : match[1]);
        const long = parseFloat(isYandex ? match[1] : match[3]);
        return [lat, long];
      } else if (match[4] && match[5]) {
        const lat = parseFloat(match[4]);
        const long = parseFloat(match[5]);
        return [lat, long];
      }
    }
    return null;
  }

  parseUrl() {
    const coord = this.extractLatLongFromUrl(this.mapUrl);
    if (coord) {
      this.value = coord;
      this.showUrlParser = false;
    } else {
      this.mapUrl = null;
    }
  }

  executeParseUrl() {
    this.showUrlParser = !this.showUrlParser;

    if (this.showUrlParser) {
      navigator.clipboard.readText()
        .then((text) => {
          this.mapUrl = text;
          if (this.mapUrl) {
            this.parseUrl();
          }
        })
        .catch((err) => {
          console.error('Metin okunurken bir hata oluştu: ', err);
        });
    }
  }
}
